import { render, staticRenderFns } from "./listBasic.vue?vue&type=template&id=7e173960&scoped=true"
import script from "./listBasic.vue?vue&type=script&lang=js"
export * from "./listBasic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e173960",
  null
  
)

export default component.exports